'use client';

import useAppSelector from 'hooks/redux/useAppSelector';
import useNoInternetNotifications from './in-app-notifications/useNoInternetNotifications';

interface IInAppNotificationsOptions {
  disabled?: boolean;
}

const useInAppNotifications = (options?: IInAppNotificationsOptions) => {
  const { disabled } = options || {};
  const { inAppNotifications } = useAppSelector(state => state.internalNotifications);

  if (!disabled) {
    useNoInternetNotifications();
  }

  return { inAppNotifications };
};

export default useInAppNotifications;
